import { render, staticRenderFns } from "./sportsSvg.vue?vue&type=template&id=f15ffbc6"
import script from "./sportsSvg.vue?vue&type=script&lang=ts"
export * from "./sportsSvg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports